/*
 * Where the app talks to.
 *
 * The localhost fallbacks apply in development only. A production bundle that
 * quietly defaults to localhost does not fail — it dials the machine of whoever
 * opened the page, which reads as "the server is down" to them and as nothing at
 * all in any log we can see. Unset in production is treated as unset.
 */
const isProduction = process.env.NODE_ENV === "production"

const API_HOST = (process.env.REACT_APP_API_BASE || (isProduction ? "" : "http://localhost:8031")).replace(/\/+$/, "")

export const baseApi = `${API_HOST}/api/v1`

const SOCKETS_HOST = (process.env.REACT_APP_SOCKETS_URL || (isProduction ? "" : "http://localhost:4010")).replace(
  /\/+$/,
  "",
)

export const socketsUrl = SOCKETS_HOST

/**
 * Whether realtime is pointed at anything.
 *
 * The sockets engine is a separate deployable and may not be up yet. Without
 * this the app opens a connection to nowhere and retries thirty times, leaving a
 * permanent "Offline" badge over an app that is otherwise working — the same
 * reason push has `pushConfigured` rather than a button that cannot work.
 * Chat and notifications still load over HTTP; only live delivery is missing.
 */
export const socketsConfigured = Boolean(SOCKETS_HOST)

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
}

export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY

/** Push needs all of these. Without them the app falls back to in-tab popups
 *  rather than showing an "enable notifications" button that cannot work. */
export const pushConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId && firebaseVapidKey,
)
